import {
	Button,
	Card,
	CardContent,
	CardHeader,
	Collapse,
	IconButton,
	makeStyles,
	Typography
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { ExpandMoreOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import moment from 'moment'
import React, { useState, useMemo } from 'react'
import { useSelector } from 'react-redux'

import AddOnsTable from '../Tables/AddOnsTable'

const useStyles = makeStyles((theme) => ({
	card: {
		backgroundColor: '#F9F9F9',
		boxShadow: 'none'
	},
	header: {
		padding: '13px 24px',
		'& .MuiCardHeader-action': {
			margin: 0
		},
		'& .MuiCardHeader-title': {
			textTransform: 'none'
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	sectionsWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		maxWidth: '68%'
	},
	reportLink: {
		//display: "flex",
		color: '#6B4AD6',
		fontSize: '16px',
		justifyContent: 'flex-start',
		fontWeight: '600',
		'& i': {
			fontSize: '16px',
			marginRight: '16px',
			color: '#6B4AD6',
			lineHeight: '20px'
		},
		'&:hover': {
			textDecoration: 'none'
		}
	},
	reports: {
		textTransform: 'capitalize',
		display: 'flex',
		fontSize: '16px',
		fontWeight: '600',
		'& i': {
			padding: '20px',
			fontSize: '16px',
			lineHeight: '20px'
		},
		'&:hover': {
			textDecoration: 'none'
		}
	}
}))

const VisitPetDetailDayDropdown = (props) => {
	const theme = useTheme()
	const classes = useStyles(theme)
	const { date, pet, visit, setIsAddAddonShown } = props
	const [isExpanded, setIsExpanded] = useState(true)
	const [isShown, setIsShown] = useState(false)
	const [selectedReport, selectReport] = useState(null)

	const facility = useSelector((state) => state.specific.facilities.selected)

	const getAddOns = () => {
		let addOns = []
		let date = moment(props.date).format('YYYY-MM-DD')
		const sortOrder = {
			morning: 0,
			midday: 1,
			evening: 2,
			night: 3
		}

		if (pet?.add_on_services && facility?.addOnTypes) {
			addOns = pet.add_on_services
				.map((a) => {
					let type = facility.addOnTypes.find((t) => t._id === a.addon_id)
					return {
						...a,
						grooming_service: type?.grooming_service ? true : false
					}
				})
				.filter(
					(add_on_service) => add_on_service.visit_id === visit._id && add_on_service.grooming_service
				)
		}

		return addOns.sort((a, b) => {
			return sortOrder[a.time] - sortOrder[b.time]
		})
	}

	const addOns = useMemo(() => getAddOns(), [pet, facility, visit, props.date])

	return (
		<Card className={classes.card}>
			<CardHeader
				className={classes.header}
				title={'Enrichments'}
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, {
							[classes.expandOpen]: isExpanded
						})}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>
					<div style={{ display: 'flex' }}>
						<div style={{ width: '100%' }}>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									width: '100%',
									marginBottom: '14px'
								}}>
								<Typography variant="overline"></Typography>
								<Button onClick={() => setIsAddAddonShown(date)}>
									<Typography
										style={{
											color: '#6B4AD6',
											fontWeight: '600px',
											fontSize: '16px',
											textTransform: 'capitalize'
										}}>
										Add New Enrichment
									</Typography>
								</Button>
							</div>
							<AddOnsTable pet={pet} addOns={addOns} grooming={true} />
						</div>
					</div>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default VisitPetDetailDayDropdown
